var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visits"},[_c('h2',{staticClass:"profile__header"},[_vm._v(_vm._s(_vm.$t('nav.recordsOld')))]),_c('div',{staticClass:"row"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }